import React from "react";

export function InfoBoxExpanded({children, selected}) {

    return(
        <div class='expanded-box-area'>
            {children}
        </div>
    )
}